import { type ReactNode } from 'react';
import clsx from 'clsx';

import styles from '../TextInput.module.css';

export function TextInputLabel(props: {
  label: ReactNode;
  activeClass: string | undefined;
  errorClass: string | undefined;
  disabledClass: string | undefined;
  labelX: string | undefined;
  labelProps: React.LabelHTMLAttributes<HTMLLabelElement>;
}) {
  const { label, activeClass, errorClass, disabledClass, labelX, labelProps } =
    props;
  return (
    <label
      {...labelProps}
      className={clsx(styles.label, activeClass, errorClass, disabledClass)}
      style={activeClass ? { left: labelX } : undefined}
    >
      {label}
    </label>
  );
}
